import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ValidationService} from '../../services/validation.service';
import {SchemaService} from '../../services/schema.service';
import {AlertController, ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {RestService} from '../../services/rest.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit {

  comment;
  formGroup: FormGroup;

  constructor(
    private restService: RestService,
    private translate: TranslateService,
    private alertController: AlertController,
    private modalCtrl: ModalController,
    private schemaService: SchemaService,
    private validationService: ValidationService) {
  }

  ngOnInit() {
    this.comment = new FormControl('',
      this.validationService.getFormValidator(this.schemaService.feedbackSchema, 'message'));
    this.formGroup = new FormGroup({
      comment: this.comment
    });
  }

  isValid(): boolean {
    return this.formGroup.valid;
  }

  async send() {
    const alert = await this.alertController.create({
      header: this.translate.instant('feedback-component.sent-it-header'),
      subHeader: this.translate.instant('feedback-component.sent-it-sub-header'),
      buttons: [
        {
          text: 'Ok',
          handler: async () => {
            await this.restService.sendFeedback({message: this.comment.value});
            await this.close();
          }
        }
      ]
    });
    await alert.present();
  }

  async close() {
    await this.modalCtrl.dismiss();
  }
}
